import React, { useEffect, useState } from "react";
import "./style.scss";
const UseMask = (props: any) => {
  return <div className="my-mask">{props.msg}</div>;
};

export default UseMask;
